import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { zodParseWithLog } from "src/api/apiErrorLogs";
import { SelectorIngredientSchema, type SelectorIngredient } from "./ingredientSchema";

type UseIngredientSelectorOptions = {
    searchText?: string;
    enabled?: boolean;
    itemsPerPage?: number;
};

export const useIngredientSelector = (options: UseIngredientSelectorOptions = {}) => {
    const { searchText = "", enabled = true, itemsPerPage = 20 } = options;

    const fetchIngredients = async () => {
        const response = await loggedInApiCall.get<{ "hydra:member": unknown }>("/api/ingredients", {
            params: {
                q: searchText || undefined,
                itemsPerPage,
                order: { name: "ASC" },
            },
        });

        return zodParseWithLog(response.data["hydra:member"], SelectorIngredientSchema.array(), "ingredientSelector");
    };

    const query = useQuery<SelectorIngredient[], Error>({
        queryKey: ["ingredientSelector", searchText, itemsPerPage],
        queryFn: fetchIngredients,
        enabled: enabled,
    });

    const { isLoading, error, ...rest } = query;

    return {
        ingredients: query.data || [],
        isLoading,
        error,
        ...rest,
    };
};
